import { Component } from '@angular/core';
import { FormControl } from '@angular/forms';
import { FieldType } from '@ngx-formly/core';

@Component({
  selector: 'app-password',
  template: `
  <p-password [formControl]="formControl"
  [formlyAttributes]="field" [toggleMask]="true" [feedback]="showPswdStrength">
        <ng-template pTemplate="header">
            <h6>Pick a password</h6>
        </ng-template>
        <ng-template pTemplate="footer">
            <p-divider></p-divider>
            <p class="p-mt-2">Suggestions:</p>
            <ul class="p-pl-2 p-ml-2 p-mt-0" style="line-height: 1.5">
                <li>Minimum 8 characters</li>
                <li>At least one uppercase</li>
                <li>At least one numeric</li>
                <li>At least one special letter</li>
            </ul>
        </ng-template>
    </p-password>
  `,
  styleUrls: ['./password.component.less']
})
export class PasswordComponent extends FieldType {

  formControl!: FormControl;
  constructor() {
    super();
  }

  ngOnInit(): void {
  }

  get showPswdStrength(): boolean {
    return (this.to.hasOwnProperty('showPswdStrength')) ? this.to.showPswdStrength : true;
  }

}
